import styled from '@emotion/styled';
import { mq } from '@styles/breakpoints';
import { Filter, FilterType } from '@model/iceberg';
import { useI18NextContext } from '@components/hooks';
import { SortBy } from '@components/filters/v2/sort-by/SortBy';

/* ***************** *
 *       Types       *
 * ***************** */
export interface TourDestinationSortProps {
  sortBy?: number;
  sortLabels: Array<string>;
  onChange: (sort: Filter) => void;
}

/* ***************** *
 *       Styles      *
 * ***************** */
const Container = styled.div(({ theme }) => ({
  ['> div']: {
    alignItems: 'center',
    display: 'flex',
    padding: `0 0 ${theme.custom.spacing.medium}px 0`,
    ['.MuiInputBase-root']: {
      width: 'unset'
    },
    [mq.small]: {
      padding: theme.custom.spacing.medium
    }
  },
  ['h5']: {
    marginBottom: 0,
    marginRight: theme.custom.spacing.small
  }
}));

/* ****************************** *
 *    TourDestinationSort         *
 * ***************************** */

export const TourDestinationSort = ({ onChange, sortBy, sortLabels }: TourDestinationSortProps) => {
  const t: any = useI18NextContext();

  const filter: Filter = {
    name: 'profile',
    formattedName: t('common__label--sort-by'),
    type: FilterType.SORT,
    values: sortLabels.map((label, idx) => ({
      value: idx,
      selected: sortBy === idx,
      count: 0,
      name: label
    }))
  };
  return (
    <Container>
      <SortBy filter={filter} onChange={onChange} />
    </Container>
  );
};
